import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RefetchDeliveryNoteMutationVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.OpsOrderFilter>;
  ids?: Types.InputMaybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>;
}>;


export type RefetchDeliveryNoteMutation = { __typename?: 'Mutation', refetchDeliveryNote: { __typename?: 'RefetchDeliveryNoteResult', delivery_note_url: string, has_errors: boolean, successful_order_ids: Array<string> } };


export const RefetchDeliveryNoteDocument = gql`
    mutation RefetchDeliveryNote($filter: OpsOrderFilter, $ids: [ID!]) {
  refetchDeliveryNote(filter: $filter, ids: $ids) {
    delivery_note_url
    has_errors
    successful_order_ids
  }
}
    `;
export type RefetchDeliveryNoteMutationFn = Apollo.MutationFunction<RefetchDeliveryNoteMutation, RefetchDeliveryNoteMutationVariables>;

/**
 * __useRefetchDeliveryNoteMutation__
 *
 * To run a mutation, you first call `useRefetchDeliveryNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefetchDeliveryNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refetchDeliveryNoteMutation, { data, loading, error }] = useRefetchDeliveryNoteMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useRefetchDeliveryNoteMutation(baseOptions?: Apollo.MutationHookOptions<RefetchDeliveryNoteMutation, RefetchDeliveryNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefetchDeliveryNoteMutation, RefetchDeliveryNoteMutationVariables>(RefetchDeliveryNoteDocument, options);
      }
export type RefetchDeliveryNoteMutationHookResult = ReturnType<typeof useRefetchDeliveryNoteMutation>;
export type RefetchDeliveryNoteMutationResult = Apollo.MutationResult<RefetchDeliveryNoteMutation>;
export type RefetchDeliveryNoteMutationOptions = Apollo.BaseMutationOptions<RefetchDeliveryNoteMutation, RefetchDeliveryNoteMutationVariables>;